// src/registry.ts
var RETURN_VARIABLE_REGISTRY = {
  "shop.name": {
    id: "shop.name",
    name: "Nom du shop",
    description: "Nom de la boutique",
    type: "string",
    group: "shop",
    requires: ["shop"],
    exampleValue: "Ma Boutique",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.shop?.name ?? null,
    setter: (ctx, value) => {
      if (ctx.shop && typeof value === "string") {
        ctx.shop.name = value;
      }
    }
  },
  "shop.contactLink": {
    id: "shop.contactLink",
    name: "Lien de contact du shop",
    description: "Lien de contact de la boutique (URL ou adresse email mailto:)",
    type: "string",
    group: "shop",
    requires: ["shop"],
    exampleValue: "https://airtable.com/appXRhhvdy7hwn00G/pagc55vfl5aITm4ER/form",
    availableIn: ["template"],
    editable: false,
    injectableInText: true,
    resolver: (ctx) => ctx.shop?.preferences?.contactLink ?? null
  },
  "customer.firstName": {
    id: "customer.firstName",
    name: "Pr\xE9nom du client",
    description: "Pr\xE9nom du client ayant effectu\xE9 le retour",
    type: "string",
    group: "customer",
    requires: ["customer"],
    exampleValue: "Sophie",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.customer?.firstName ?? null,
    setter: (ctx, value) => {
      if (ctx.customer && typeof value === "string") {
        ctx.customer.firstName = value;
      }
    }
  },
  "customer.lastName": {
    id: "customer.lastName",
    name: "Nom du client",
    description: "Nom du client ayant effectu\xE9 le retour",
    type: "string",
    group: "customer",
    requires: ["customer"],
    exampleValue: "Martin",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.customer?.lastName ?? null,
    setter: (ctx, value) => {
      if (ctx.customer && typeof value === "string") {
        ctx.customer.lastName = value;
      }
    }
  },
  "customer.email": {
    id: "customer.email",
    name: "Email du client",
    description: "Adresse email du client",
    type: "string",
    group: "customer",
    requires: ["customer"],
    exampleValue: "sophie.martin@example.com",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.customer?.email ?? null,
    setter: (ctx, value) => {
      if (ctx.customer && typeof value === "string") {
        ctx.customer.email = value;
      }
    }
  },
  "return.id": {
    id: "return.id",
    name: "Identifiant du retour",
    description: "Identifiant unique de la demande de retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "RET-10042",
    availableIn: ["template"],
    editable: false,
    resolver: (ctx) => ctx.return?.id ?? null
  },
  "return.orderName": {
    id: "return.orderName",
    name: "Num\xE9ro de commande",
    description: "Num\xE9ro de la commande associ\xE9e au retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "#1042",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.orderName ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.orderName = value;
      }
    }
  },
  "return.status": {
    id: "return.status",
    name: "Statut du retour",
    description: "Statut actuel de la demande de retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "approved",
    availableIn: ["template"],
    editable: false,
    resolver: (ctx) => ctx.return?.status ?? null
  },
  "return.reason": {
    id: "return.reason",
    name: "Motif du retour",
    description: "Raison indiqu\xE9e par le client pour le retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "Taille incorrecte",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.reason ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.reason = value;
      }
    }
  },
  "return.createdAt": {
    id: "return.createdAt",
    name: "Date de cr\xE9ation",
    description: "Date de cr\xE9ation de la demande de retour (timestamp ms)",
    type: "number",
    group: "return",
    requires: ["return"],
    exampleValue: Date.now(),
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.createdAt ?? null
  },
  "return.requestTimezone": {
    id: "return.requestTimezone",
    name: "Fuseau horaire de la demande",
    description: "Fuseau horaire IANA (ex. \xAB Europe/Paris \xBB) utilis\xE9 par le bloc Date de la demande pour formater la date de cr\xE9ation dans la langue du mail. Pr\xE9sent uniquement pour les clients europ\xE9ens.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "Europe/Paris",
    // In "template" so the editor seeds the example value (drives the block
    // preview); hidden from the `@` picker via `pickable: false` in the editor.
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.requestTimezone ?? null
  },
  "return.refundAmount": {
    id: "return.refundAmount",
    name: "Montant rembours\xE9",
    description: "Montant du remboursement",
    type: "number",
    group: "return",
    requires: ["return"],
    exampleValue: 49.99,
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.refundAmount ?? null,
    setter: (ctx, value) => {
      const amount = typeof value === "number" ? value : Number(value);
      if (ctx.return && Number.isFinite(amount)) {
        ctx.return.refundAmount = amount;
      }
    }
  },
  "return.refundCurrency": {
    id: "return.refundCurrency",
    name: "Devise du remboursement",
    description: "Devise du montant rembours\xE9 (EUR, USD, etc.)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "EUR",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.refundCurrency ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.refundCurrency = value;
      }
    }
  },
  "return.discountCode": {
    id: "return.discountCode",
    name: "Code de r\xE9duction",
    description: "Code de r\xE9duction ou de carte cadeau \xE9mis suite au retour (vide pour un avoir / store credit). Utilis\xE9 par le bloc Code de r\xE9duction.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "BABACK-3F9K2",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.discountCode ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.discountCode = value;
      }
    }
  },
  "return.discountValue": {
    id: "return.discountValue",
    name: "Montant de l'avoir",
    description: "Montant du code de r\xE9duction / de l'avoir \xE9mis suite au retour",
    // String, not number: preserves the amount's decimals as provided ("30.00",
    // "12.50"). A number would drop trailing zeros (30.00 === 30 in JS),
    // rendering "30"/"12.5". Mirrors the line-items block, which keeps prices as
    // strings.
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "30.00",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.discountValue ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.discountValue = value;
      }
    }
  },
  "return.discountCurrency": {
    id: "return.discountCurrency",
    name: "Devise de l'avoir",
    description: "Devise du montant du code de r\xE9duction / de l'avoir (EUR, USD, etc.)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "EUR",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.discountCurrency ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.discountCurrency = value;
      }
    }
  },
  "return.discountValidUntil": {
    id: "return.discountValidUntil",
    name: "Date de validit\xE9 de l'avoir",
    description: "Date d'expiration du code de r\xE9duction / de l'avoir, format\xE9e et localis\xE9e (ex. \xAB 16 juin 2026 \xBB). Vide si aucune date d'expiration.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "16 septembre 2026",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.discountValidUntil ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.discountValidUntil = value;
      }
    }
  },
  "return.labelUrl": {
    id: "return.labelUrl",
    name: "URL \xE9tiquette retour",
    description: "Lien de t\xE9l\xE9chargement de l'\xE9tiquette de retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "https://labels.example.com/return/abc123.pdf",
    availableIn: ["template"],
    editable: false,
    resolver: (ctx) => ctx.return?.labelUrl ?? null
  },
  "return.dropPointFinderUrl": {
    id: "return.dropPointFinderUrl",
    name: "URL point de d\xE9p\xF4t",
    description: "Lien vers le localisateur de points de d\xE9p\xF4t pour d\xE9poser le colis retour (\xE0 utiliser dans un bouton CTA)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "https://localiser.laposte.fr/?jesuis=particulier&qp=12%20Rue%20de%20Bretagne%2C%2075003%2C%20Paris%2C%20France",
    availableIn: ["template"],
    editable: false,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.dropPointFinderUrl ?? null
  },
  "return.trackingCode": {
    id: "return.trackingCode",
    name: "Num\xE9ro de suivi retour",
    description: "Num\xE9ro de suivi du colis retourn\xE9",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "1Z999AA10123456784",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.trackingCode ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.trackingCode = value;
      }
    }
  },
  "return.trackingUrl": {
    id: "return.trackingUrl",
    name: "URL de suivi du retour",
    description: "Lien vers la page de suivi et gestion du retour (\xE0 utiliser dans un bouton CTA)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "https://my-shop.com/a/return?shop=shop-id&orderId=order-id",
    availableIn: ["template"],
    editable: false,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.trackingUrl ?? null
  },
  "return.carrierCode": {
    id: "return.carrierCode",
    name: "Code transporteur",
    description: "Code interne du transporteur du retour (ex. colissimo, ups-express). Utilis\xE9 par le bloc Instructions de livraison.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "colissimo",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.carrierCode ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.carrierCode = value;
      }
    }
  },
  "return.hasLogisticLabel": {
    id: "return.hasLogisticLabel",
    name: "Bon de retour logistique",
    description: "Indique si le retour utilise un bon de retour logistique. Utilis\xE9 par le bloc Instructions de livraison.",
    type: "boolean",
    group: "return",
    requires: ["return"],
    exampleValue: false,
    availableIn: [],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.hasLogisticLabel ?? null
  },
  "return.store": {
    id: "return.store",
    name: "Boutique de retour",
    description: "Informations sur la boutique o\xF9 d\xE9poser le retour (disponible uniquement pour les retours en boutique)",
    type: "object",
    group: "return",
    requires: ["return"],
    exampleValue: {
      name: "Boutique Paris Marais",
      address1: "12 Rue de Bretagne",
      address2: null,
      city: "Paris",
      zip: "75003",
      country: "France",
      mapUrl: "https://www.google.com/maps/place/12+Rue+de+Bretagne+75003+Paris"
    },
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.store ?? null
  },
  "return.resolutions": {
    id: "return.resolutions",
    name: "R\xE9solutions du retour",
    description: "R\xE9solutions choisies pour les articles r\xE9ellement retourn\xE9s, en libell\xE9s lisibles, d\xE9doublonn\xE9es et s\xE9par\xE9es par \xAB , \xBB (ex. \xAB Remboursement, \xC9change \xBB). Vide si aucun article n'a de r\xE9solution.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "Remboursement, \xC9change, Bon d'achat",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    // `?? ""` and never `null`: the renderer falls a nullish value back to
    // `exampleValue` above, which would leak it into a real email.
    resolver: (ctx) => ctx.return?.resolutions ?? "",
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.resolutions = value;
      }
    }
  },
  "return.items": {
    id: "return.items",
    name: "Articles retourn\xE9s",
    description: "Liste des articles inclus dans le retour. Sur un email d'acceptation ou de refus, uniquement les articles du lot trait\xE9 : un traitement partiel ne pr\xE9sente pas les articles accept\xE9s comme refus\xE9s.",
    type: "array",
    group: "return",
    requires: ["return"],
    exampleValue: [
      {
        name: "Robe fleurie taille M",
        quantity: 1,
        price: "49.99",
        paidPrice: "49.99",
        sku: "ROBE-M-001",
        imageUrl: "https://placehold.co/100x100",
        reason: "Taille incorrecte",
        resolution: "refund"
      },
      {
        name: "T-shirt coton",
        quantity: 1,
        price: "19.99",
        sku: "TSHIRT-L-002",
        imageUrl: "https://placehold.co/100x100",
        reason: "\xC9change de taille",
        resolution: "exchange",
        variant: { title: "L" },
        newVariant: { option1: "XL" }
      },
      {
        name: "Pull en laine",
        quantity: 2,
        price: "79.00",
        sku: "PULL-S-003",
        imageUrl: "https://placehold.co/100x100",
        reason: "Ne convient pas",
        resolution: "exchange-credit"
      },
      {
        name: "Casquette",
        quantity: 1,
        price: "24.50",
        sku: "CAP-001",
        imageUrl: "https://placehold.co/100x100",
        reason: "Geste commercial",
        resolution: "discount"
      }
    ],
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.items ?? null
  },
  "return.exchangeItems": {
    id: "return.exchangeItems",
    name: "Articles re\xE7us en \xE9change",
    description: "Liste des nouveaux articles envoy\xE9s au client en \xE9change (\xE9change de taille et \xE9change-cr\xE9dit). Toujours vide sur un email de refus, qui n'annonce jamais de nouvelle commande.",
    type: "array",
    group: "return",
    requires: ["return"],
    exampleValue: [
      {
        name: "Chemise rose en coton dobby - 4XL",
        quantity: 1,
        price: "140.00",
        sku: null,
        imageUrl: "https://placehold.co/100x100"
      },
      {
        name: "Chaussettes rose gris\xE9 coton - 39/42",
        quantity: 2,
        price: "12.00",
        sku: null,
        imageUrl: "https://placehold.co/100x100"
      }
    ],
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    // `[]` and never `null`: the email renderer falls a nullish value back to
    // `exampleValue` (`variablesValues[id] ?? definition.exampleValue`), which
    // would leak the placeholder products above into a real email.
    resolver: (ctx) => ctx.return?.exchangeItems ?? []
  }
};
var RETURN_VARIABLE_MAP = new Map(
  Object.entries(RETURN_VARIABLE_REGISTRY).map(([id, v]) => [id, v])
);
function getReturnVariableDefinition(id) {
  return RETURN_VARIABLE_MAP.get(id);
}

// src/subsets.ts
var RETURN_TEMPLATE_VARIABLES = Object.values(RETURN_VARIABLE_REGISTRY).filter(
  (v) => v.availableIn.includes("template")
);
function getReturnVariablesByGroup(variables) {
  return variables.reduce(
    (acc, variable) => {
      if (!acc[variable.group]) {
        acc[variable.group] = [];
      }
      acc[variable.group].push(variable);
      return acc;
    },
    {}
  );
}
function getActiveReturnVariables(variables) {
  return variables.filter((v) => !v.deprecated);
}

// src/resolution-labels.ts
var RETURN_RESOLUTION_ORDER = [
  "refund",
  "exchange",
  "exchange-credit",
  "discount"
];
var RETURN_RESOLUTION_LABELS = {
  bg: {
    refund: "\u0412\u044A\u0437\u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430",
    exchange: "\u0417\u0430\u043C\u044F\u043D\u0430",
    "exchange-credit": "\u0417\u0430\u043C\u044F\u043D\u0430",
    discount: "\u041A\u043E\u0434 \u0437\u0430 \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430"
  },
  cs: {
    refund: "Vr\xE1cen\xED pen\u011Bz",
    exchange: "V\xFDm\u011Bna",
    "exchange-credit": "V\xFDm\u011Bna",
    discount: "Slevov\xFD k\xF3d"
  },
  da: {
    refund: "Refundering",
    exchange: "Ombytning",
    "exchange-credit": "Ombytning",
    discount: "Rabatkode"
  },
  de: {
    refund: "R\xFCckerstattung",
    exchange: "Umtausch",
    "exchange-credit": "Umtausch",
    discount: "Rabatt"
  },
  en: {
    refund: "Refund",
    exchange: "Exchange",
    "exchange-credit": "Exchange",
    discount: "Discount code"
  },
  es: {
    refund: "Reembolso",
    exchange: "Cambio",
    "exchange-credit": "Cambio",
    discount: "Cup\xF3n de descuento"
  },
  fi: {
    refund: "Hyvitys",
    exchange: "Vaihto",
    "exchange-credit": "Vaihto",
    discount: "Alennuskoodi"
  },
  fr: {
    refund: "Remboursement",
    exchange: "\xC9change",
    "exchange-credit": "\xC9change",
    discount: "Bon d'achat"
  },
  hu: {
    refund: "Visszat\xE9r\xEDt\xE9s",
    exchange: "Csere",
    "exchange-credit": "Csere",
    discount: "Kedvezm\xE9ny k\xF3d"
  },
  it: {
    refund: "Rimborso",
    exchange: "Cambio",
    "exchange-credit": "Cambio",
    discount: "Codice sconto"
  },
  ja: {
    refund: "\u8FD4\u91D1",
    exchange: "\u4EA4\u63DB",
    "exchange-credit": "\u4EA4\u63DB",
    discount: "\u5272\u5F15\u30B3\u30FC\u30C9"
  },
  nl: {
    refund: "Terugbetaling",
    exchange: "Ruil",
    "exchange-credit": "Ruil",
    discount: "Kortingscode"
  },
  no: {
    refund: "Tilbakebetaling",
    exchange: "Bytte",
    "exchange-credit": "Bytte",
    discount: "Rabattkode"
  },
  pl: {
    refund: "Refundacja",
    exchange: "Wymiana",
    "exchange-credit": "Wymiana",
    discount: "Kod rabatowy"
  },
  pt: {
    refund: "Reembolso",
    exchange: "Troca",
    "exchange-credit": "Troca",
    discount: "C\xF3digo de desconto"
  },
  sk: {
    refund: "Vr\xE1tenie pe\u0148az\xED",
    exchange: "V\xFDmena",
    "exchange-credit": "V\xFDmena",
    discount: "Z\u013Eavov\xFD k\xF3d"
  },
  sv: {
    refund: "\xC5terbetalning",
    exchange: "Byte",
    "exchange-credit": "Byte",
    discount: "Rabattkod"
  },
  zh: {
    refund: "\u9000\u6B3E",
    exchange: "\u6362\u8D27",
    "exchange-credit": "\u6362\u8D27",
    discount: "\u6298\u6263\u7801"
  }
};
function toLabelLocale(locale) {
  const base = (locale ?? "en").toLowerCase().split(/[-_]/)[0];
  return base in RETURN_RESOLUTION_LABELS ? base : "en";
}
function formatReturnResolutions(items, locale) {
  const labels = RETURN_RESOLUTION_LABELS[toLabelLocale(locale)];
  const present = new Set(
    (items ?? []).filter((item) => (item.quantity ?? 0) > 0 && item.resolution).map((item) => item.resolution)
  );
  const seen = /* @__PURE__ */ new Set();
  const rendered = [];
  for (const resolution of RETURN_RESOLUTION_ORDER) {
    if (!present.has(resolution)) continue;
    const label = labels[resolution];
    if (!label || seen.has(label)) continue;
    seen.add(label);
    rendered.push(label);
  }
  return rendered.join(", ");
}

// src/groups.ts
var RETURN_VARIABLE_GROUPS = {
  shop: {
    icon: "store",
    labelKey: "returnVariableGroups.shop"
  },
  customer: {
    icon: "user",
    labelKey: "returnVariableGroups.customer"
  },
  return: {
    icon: "package",
    labelKey: "returnVariableGroups.return"
  }
};

// src/contexts.ts
var DISCOUNT_VARIABLE_IDS = [
  "return.discountCode",
  "return.discountValue",
  "return.discountCurrency",
  "return.discountValidUntil"
];
var RETURN_VARIABLE_CONTEXTS = {
  return_event: {
    id: "return_event",
    name: "Return Event",
    description: "Base return lifecycle context with the return request, shop and customer. Discount variables are excluded: their data only exists on the discount-created event.",
    provides: ["shop", "return", "customer"],
    excludes: DISCOUNT_VARIABLE_IDS
  },
  return_discount_event: {
    id: "return_discount_event",
    name: "Return Discount Event",
    description: "Discount / gift card / store credit issued for the return: full return context plus the discount variables carried by the event.",
    provides: ["shop", "return", "customer"]
  }
};
function getVariablesForReturnContext(contextType) {
  const context = RETURN_VARIABLE_CONTEXTS[contextType];
  if (!context) {
    return [];
  }
  const providedSources = new Set(context.provides);
  const excluded = new Set(context.excludes ?? []);
  return Object.entries(RETURN_VARIABLE_REGISTRY).filter(([id, definition]) => {
    if (excluded.has(id)) {
      return false;
    }
    return definition.requires.some((source) => providedSources.has(source));
  }).map(([id]) => id);
}
function isReturnVariableAvailableInContext(variableId, contextType) {
  const definition = RETURN_VARIABLE_REGISTRY[variableId];
  if (!definition) {
    return false;
  }
  const context = RETURN_VARIABLE_CONTEXTS[contextType];
  if (!context) {
    return false;
  }
  if (context.excludes?.includes(variableId)) {
    return false;
  }
  return definition.requires.some((source) => context.provides.includes(source));
}
function getUnavailableReturnVariables(variableIds, contextType) {
  return variableIds.filter((id) => !isReturnVariableAvailableInContext(id, contextType));
}
function getAvailableReturnVariables(variableIds, contextType) {
  return variableIds.filter((id) => isReturnVariableAvailableInContext(id, contextType));
}
var RETURN_TRIGGER_VARIABLE_CONTEXTS = {
  return_created: "return_event",
  return_cancelled: "return_event",
  return_need_approval: "return_event",
  return_approved: "return_event",
  return_merchant_approved: "return_event",
  return_merchant_rejected: "return_event",
  return_shipping_label_created: "return_event",
  return_shipping_label_error: "return_event",
  return_discount_created: "return_discount_event",
  return_payment_refunded: "return_event",
  return_deposit_reminder: "return_event",
  return_resolution_updated: "return_event",
  return_logistician_approved: "return_event",
  return_logistician_rejected: "return_event",
  return_treatment_error: "return_event",
  return_delivered: "return_event"
};
function getVariablesForReturnTrigger(triggerType) {
  const contextType = RETURN_TRIGGER_VARIABLE_CONTEXTS[triggerType];
  return getVariablesForReturnContext(contextType);
}

// src/provider.tsx
function resolveReturnVariables(context) {
  const values = {};
  Object.values(RETURN_VARIABLE_REGISTRY).forEach((variable) => {
    values[variable.id] = variable.resolver(context);
  });
  return values;
}
function getReturnVariableExampleContext(shop) {
  const example = (id) => RETURN_VARIABLE_REGISTRY[id].exampleValue;
  return {
    shop: shop ?? null,
    customer: {
      firstName: example("customer.firstName"),
      lastName: example("customer.lastName"),
      email: example("customer.email")
    },
    return: {
      id: example("return.id"),
      orderName: example("return.orderName"),
      status: example("return.status"),
      reason: example("return.reason"),
      createdAt: example("return.createdAt"),
      requestTimezone: example("return.requestTimezone"),
      refundAmount: example("return.refundAmount"),
      refundCurrency: example("return.refundCurrency"),
      discountCode: example("return.discountCode"),
      discountValue: example("return.discountValue"),
      discountCurrency: example("return.discountCurrency"),
      discountValidUntil: example("return.discountValidUntil"),
      labelUrl: example("return.labelUrl"),
      trackingCode: example("return.trackingCode"),
      trackingUrl: example("return.trackingUrl"),
      dropPointFinderUrl: example("return.dropPointFinderUrl"),
      carrierCode: example("return.carrierCode"),
      hasLogisticLabel: example("return.hasLogisticLabel"),
      store: example(
        "return.store"
      ),
      resolutions: example("return.resolutions"),
      items: example("return.items"),
      exchangeItems: example("return.exchangeItems")
    }
  };
}
function applyReturnVariables(context, variables) {
  if (!variables) return context;
  for (const [variableId, value] of Object.entries(variables)) {
    if (value === void 0) continue;
    const definition = getReturnVariableDefinition(variableId);
    if (!definition?.setter) continue;
    try {
      definition.setter(context, value);
    } catch {
    }
  }
  return context;
}
function createReturnFormatter(values) {
  return (text) => {
    if (!text?.trim().length) return "";
    return text.replace(/\{\{\s*([^}]+)\s*\}\}/g, (match, variableId) => {
      const trimmedId = variableId.trim();
      const value = values[trimmedId];
      const definition = getReturnVariableDefinition(trimmedId);
      if (definition?.injectableInText === false) {
        return match;
      }
      if (value === void 0 || value === null) {
        return definition ? "" : match;
      }
      if (typeof value === "object" && value !== null && !(value instanceof Date)) {
        return match;
      }
      return String(value);
    });
  };
}

export { RETURN_RESOLUTION_LABELS, RETURN_RESOLUTION_ORDER, RETURN_TEMPLATE_VARIABLES, RETURN_TRIGGER_VARIABLE_CONTEXTS, RETURN_VARIABLE_CONTEXTS, RETURN_VARIABLE_GROUPS, RETURN_VARIABLE_MAP, RETURN_VARIABLE_REGISTRY, applyReturnVariables, createReturnFormatter, formatReturnResolutions, getActiveReturnVariables, getAvailableReturnVariables, getReturnVariableDefinition, getReturnVariableExampleContext, getReturnVariablesByGroup, getUnavailableReturnVariables, getVariablesForReturnContext, getVariablesForReturnTrigger, isReturnVariableAvailableInContext, resolveReturnVariables };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map